

























































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import moment from "moment";
import Gailan from "./shijuangailan.vue";
import { GetTestQuestionsList$, GetExamDetail$ } from "@/request/jxgl";
import {
  FinishExam$,
  GetStudentInfo$,
  GetExamAnswerDetail$,
} from "@/request/shezhenjiaoxue";
import Danxuan from "./danxuan.vue";
import Duoxuan from "./duoxuan.vue";
import CompleteDialog from "./complete.vue";
@Component({
  components: {
    Gailan,
    Danxuan,
    Duoxuan,
    CompleteDialog,
  },
})
export default class SzksDetail extends Vue {
  private test: any = {
    create_time: "",
  };
  private exam: any = {};
  private student: any = {};
  private filters: any = {
    current_page: 1,
    total_count: 0,
    total_page: 0,
    page_count: 5,
  };
  private leftTime: number = 60;
  private answers: any[] = [];
  private ifShowResult: boolean = false;
  private result: any = {};
  private interval: any = {};
  /**
   * @description 获得试卷详情
   */
  private fetchTestDetail() {
    const params: any = {
      test_id: this.test.test_id,
      current_page: this.filters["current_page"],
      page_count: this.filters["page_count"],
    };
    GetTestQuestionsList$(this, params).then((data: any) => {
      this.$set(this, "test", data);
      this.filters.total_count = data.total_count;
      this.filters.total_page = data.total_page;
    });
    GetExamAnswerDetail$(this, { params: { exam_id: this.exam.exam_id } }).then(
      (data: any) => {
        // console.log(data);
        this.$set(this, "answers", _.cloneDeep(data["questions"]));
      }
    );
  }
  /**
   * @description 获取考试详情
   */
  private fetchExamDetail() {
    const params: any = {
      params: {
        exam_id: this.exam.exam_id,
      },
    };
    GetExamDetail$(this, params).then((data: any) => {
      this.$set(this, "exam", data);
      this.leftTime = moment(this.exam["结束时间"]).diff(
        moment.now(),
        "minutes"
      );
      this.countDown();
    });
  }
  /**
   * @description 倒计时
   */
  private countDown() {
    this.interval = setInterval(() => {
      this.leftTime--;
      if (this.leftTime <= 0) {
        clearInterval(this.interval);
        this.save().then(() => {
          this.showComplete();
        });
      }
    }, 1000 * 60);
  }

  /**
   * @description 获得学生信息
   */
  private fetchStudentDetail() {
    const params: any = {
      params: {
        exam_id: this.exam.exam_id,
      },
    };
    GetStudentInfo$(this, params).then((data: any) => {
      this.$set(this, "student", data);
    });
  }
  /**
   * @description 单选选中了一项
   */
  private danxuanSelectOne(item, index) {
    const targetIndex =
      index + (this.filters["current_page"] - 1) * this.filters.page_count;
    this.answers[targetIndex]["reply"] = [item];
    this.answers[targetIndex]["is_reply"] = true;
  }
  /**
   * @description 多选选中了一项
   */
  private duoxuanSelectOne(item, index) {
    const targetIndex =
      index + (this.filters["current_page"] - 1) * this.filters.page_count;
    const inx = this.answers[targetIndex]["reply"].indexOf(item);
    if (inx === -1) {
      this.answers[targetIndex]["reply"].push(item);
      this.answers[targetIndex]["is_reply"] = true;
    } else {
      this.answers[targetIndex]["reply"].splice(inx, 1);
      if (this.answers[targetIndex]["reply"].length > 0) {
        this.answers[targetIndex]["is_reply"] = true;
      } else {
        this.answers[targetIndex]["is_reply"] = false;
      }
    }
    this.$forceUpdate();
  }
  /**
   * @description 上一页
   */
  private prev() {
    this.fanye().then(() => {
      this.filters.current_page--;
      this.fetchTestDetail();
      this.$nextTick().then(() => {
        setTimeout(() => {
          (this.$refs.questionWrap as any).scrollTop = 0;
        }, 1000);
      });
    });
  }
  /**
   * @description 下一页
   */
  private next() {
    this.fanye().then(() => {
      this.filters.current_page++;
      this.fetchTestDetail();
      this.$nextTick().then(() => {
        setTimeout(() => {
          (this.$refs.questionWrap as any).scrollTop = 0;
        }, 1000);
      });
    });
  }
  /**
   * @description 跳转到某题目的页面
   */
  private jumpTo(index) {
    const target = Math.ceil((index + 1) / this.filters.page_count);
    if (target === this.filters.current_page) {
      return;
    }
    this.fanye().then(() => {
      this.filters.current_page = target;
      this.fetchTestDetail();
    });
  }
  /**
   * @description 翻页临时保存答案
   */
  private fanye() {
    return new Promise((resolve, reject) => {
      const params: any = {
        exam_id: this.exam.exam_id,
        replies: this.answers,
        is_done: false,
      };
      FinishExam$(this, params)
        .then((data: any) => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 交卷
   */
  private save() {
    return new Promise((resolve, reject) => {
      const params: any = {
        exam_id: this.exam.exam_id,
        replies: this.answers,
        is_done: true,
      };
      FinishExam$(this, params)
        .then((data: any) => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 提前交卷
   */
  private aheadSave() {
    this.$confirm("请认真检查后再提交，提交后将无法修改！", {
      title: "确认提前交卷？",
      cancelButtonText: "再检查检查",
      confirmButtonText: "我要交卷",
    })
      .then(() => {
        this.save().then(() => {
          this.showComplete();
        });
      })
      .catch(() => {
        console.log(this.test);
      });
  }
  /**
   * @description 展示完成
   */
  private showComplete() {
    GetExamAnswerDetail$(this, { params: { exam_id: this.exam.exam_id } }).then(
      (data: any) => {
        console.log(data);
        this.$set(this, "result", _.cloneDeep(data));
        this.ifShowResult = true;
      }
    );
  }
  /**
   * @description 离开页面前提示
   */
  private beforeRouteLeave(to, from, next) {
    if (this.result.reply_id) {
      next(true);
    } else {
      this.$confirm(
        "离开当前页面将直接提交试卷，不可返回修改，确定要离开嘛？",
        {
          title: "温馨提示",
          cancelButtonText: "还要答题",
          confirmButtonText: "我要交卷",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        }
      )
        .then(() => {
          this.save()
            .then(() => {
              next(true);
            })
            .catch(() => {
              next(false);
            });
        })
        .catch(() => {
          next(false);
        });
    }
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.$route.query.test_id && this.$route.query.exam_id) {
      this.test.test_id = this.$route.query.test_id;
      this.exam.exam_id = this.$route.query.exam_id;
      this.fetchTestDetail();
      this.fetchExamDetail();
      this.fetchStudentDetail();
    } else {
      this.$message.error("参数有误，请重新预览");
    }
  }
  /**
   * @description 销毁定时器
   */
  private destroyed() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
